import equals from 'ramda/src/equals'
import { idProp } from 'root/src/client/logic/api/lenses'
import { AUDIT_FAVORITES } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'

import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import updateProjectRecord from 'root/src/client/logic/api/actions/updateProjectRecord'
import apiRecordRequestError from 'root/src/client/logic/api/actions/apiRecordRequestError'
import favoritesProcessingStart from 'root/src/client/logic/project/actions/favoritesProcessingStart'
import favoritesProcessingEnd from 'root/src/client/logic/project/actions/favoritesProcessingEnd'

export default () => async (dispatch, getState) => {
	const state = getState()

	const projectUrl = currentRouteParamsRecordId(state)
	const payload = { projectUrl }

	// set the favorites button loading
	dispatch(favoritesProcessingStart())

	const recordType = project
	const recordId = idProp(payload)
	const lambdaRes = await invokeApiRequest(AUDIT_FAVORITES, payload, state)
	const { statusCode, body, statusError, generalError } = lambdaRes
	if (equals(statusCode, 200)) {
		dispatch(updateProjectRecord(body))
		dispatch(favoritesProcessingEnd())
	} if (recordId) { // else creating, don't need record error state
		const error = { ...statusError, ...generalError }
		dispatch(apiRecordRequestError(recordType, recordId, error))
		dispatch(favoritesProcessingEnd())
	}

	return lambdaRes
}
